/**
 * FE-C2g batch-9/10: Group HTTP contract paths (v1 primary + legacy fallbacks).
 */

import { buildContractPath } from "./api/contract-client.js";

/** @param {string} [ownerAdmin] */
function ownerQuery(ownerAdmin) {
  const o = String(ownerAdmin || "").trim();
  return o ? { owner_admin: o } : undefined;
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildGetGroupsV1SettingsPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("get__groups_v1_p_settings", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPutGroupsV1SettingsPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("put__groups_v1_p_settings", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPostGroupsV1ApplyPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("post__groups_v1_p_apply", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildDeleteGroupsV1Path(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("delete__groups_v1_p", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupDisplay @param {string} [ownerAdmin] */
export function buildGetGroupsV1SharesPath(groupDisplay, ownerAdmin) {
  const query = { group_display: String(groupDisplay || "").trim() };
  const oq = ownerQuery(ownerAdmin);
  if (oq) Object.assign(query, oq);
  return buildContractPath("get__groups_v1_shares", { query });
}

export function buildPutGroupsV1SharesPath() {
  return buildContractPath("put__groups_v1_shares");
}

export function buildPostGroupsV1SharesBulkRevokePath() {
  return buildContractPath("post__groups_v1_shares_bulk-revoke");
}

/** @param {string} [ownerAdmin] */
export function buildGetGroupCardsSettingsPath(ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("get__group-cards_settings", query ? { query } : undefined);
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPutGroupCardsSettingsPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("put__group-cards_p_settings", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPostGroupCardsApplyPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("post__group-cards_p_apply", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildDeleteGroupCardsPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("delete__group-cards_p", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPostGroupCardsDeletePath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("post__group-cards_p_delete", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildDeleteNotificationGroupsPath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("delete__notification-groups_p", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}

/** @param {string} groupKey @param {string} [ownerAdmin] */
export function buildPostNotificationGroupsDeletePath(groupKey, ownerAdmin) {
  const query = ownerQuery(ownerAdmin);
  return buildContractPath("post__notification-groups_p_delete", {
    pathParams: [groupKey],
    ...(query ? { query } : {}),
  });
}
